import { useState } from "react";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { submitLead } from "@/lib/api";

const INTERESTS = [
  "The Chaos Audit",
  "Systems Sprint",
  "Scale Calm Mentorship",
  "Something else",
];

const inputCls =
  "w-full bg-transparent border-b border-border py-4 text-ink placeholder:text-neutral-400 outline-none focus:border-sage transition-colors duration-300 text-base";

export const EnquiryForm = ({ defaultInterest = "" }) => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    interest: defaultInterest,
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await submitLead({ type: "enquiry", ...form });
      toast.success("Received. Expect a calm, human reply within two days.");
      setForm({ name: "", email: "", interest: "", message: "" });
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form data-testid="enquiry-form" onSubmit={onSubmit} className="flex flex-col gap-8">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
        <input
          data-testid="enquiry-name-input"
          required
          value={form.name}
          onChange={set("name")}
          placeholder="Your name"
          className={inputCls}
        />
        <input
          data-testid="enquiry-email-input"
          type="email"
          required
          value={form.email}
          onChange={set("email")}
          placeholder="your@email.com"
          className={inputCls}
        />
      </div>

      <div>
        <p className="text-xs uppercase tracking-[0.25em] text-neutral-500 mb-4">
          I'm curious about
        </p>
        <div className="flex flex-wrap gap-3">
          {INTERESTS.map((i) => (
            <button
              key={i}
              type="button"
              data-testid={`enquiry-interest-${i.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => setForm({ ...form, interest: i })}
              className={`rounded-full px-5 py-2.5 text-sm border transition-colors duration-300 ${
                form.interest === i
                  ? "bg-sage text-sand border-sage"
                  : "border-border text-neutral-600 hover:border-sage hover:text-sage"
              }`}
            >
              {i}
            </button>
          ))}
        </div>
      </div>

      <textarea
        data-testid="enquiry-message-input"
        required
        rows={4}
        value={form.message}
        onChange={set("message")}
        placeholder="Tell me where the chaos lives in your business right now..."
        className={`${inputCls} resize-none`}
      />

      <button
        data-testid="enquiry-submit-button"
        type="submit"
        disabled={loading}
        className="group w-fit rounded-full bg-sage text-sand px-8 py-4 text-sm tracking-wide hover:bg-ink transition-colors duration-300 disabled:opacity-50 flex items-center gap-3"
      >
        {loading ? "Sending..." : "Send enquiry"}
        <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" />
      </button>
    </form>
  );
};
